import React, { useEffect, useState } from "react"
import {
  View,
  Text,
  FlatList,
  TouchableOpacity,
  StyleSheet,
  Dimensions
} from "react-native"
import moment from "moment"
import getPlatformType from "../../../helpers/helpers"
import IssueDetailsModal from "../../../components/maintainance/IssueDetailsModal"
import { maintenanceService } from "../../../redux/action/maintenance.service"
import { COLORS } from "../../tenants/tenantOnboarding/screens/components/PropertyDetailsCard"

interface Props {
  flos?: any[]
  editView: (row: any) => void
  refresh: (row: any) => void
  updateIssueStatus?: (issue: any, status: string) => void,
  type?: string

}

function ActiveProjectIssueTable({ flos = [], editView, updateIssueStatus, type, refresh }: Props) {

  const layout = getPlatformType()
  const isMobile = layout === "mobile" || Dimensions.get("window").width < 768

  const [list, setList] = useState<any[]>([])
  const [selected, setSelected] = useState<number[]>([])
  const [selectedIssue, setSelectedIssue] = useState(null)
  const [openModal, setOpenModal] = useState(false)
  const [loader, setLoader] = useState(false)


  const [openSelfManage, setOpenSelfManage] = useState(false)
  const [selectedIssues, setSelectedIssues] = useState<any[]>([])
  useEffect(() => {
    setList(flos || [])
  }, [flos])



  const getStatusStyle = (status: string) => {
    if (status === "completed") {
      return { bg: "#DCFCE7", text: "#15803D" }
    }
    if (status === "inprogress") {
      return { bg: "#FEF3C7", text: "#B45309" }
    }
    return { bg: "#EDE9FE", text: "#6D28D9" }
  }

  const handleUpdateIssueStatus = (row: any) => {
    if (updateIssueStatus) {
      const status = row.status == 'pending' ? 'inprogress' : 'completed';
      updateIssueStatus(row, status)
    }
  }

  const renderDesktopRow = ({ item }: any) => {

    const statusStyle = getStatusStyle(item.status)

    return (
      <View style={styles.row}>

        <View style={styles.colStatus}>
          <View style={[styles.statusBadge, { backgroundColor: statusStyle.bg }]}>
            <Text style={[styles.statusText, { color: statusStyle.text }]}>
              {item.status?.toUpperCase()}
            </Text>
          </View>
        </View>

        <View style={styles.colTitle}>
          <Text style={styles.titleText} numberOfLines={1}>
            {item.title || "Untitled"}
          </Text>
        </View>

        <View style={styles.colDate}>
          <Text style={styles.cellText}>
            {moment(item.date_opened).format("DD MMM YYYY")}
          </Text>
        </View>

        <View style={styles.colReported}>
          <Text style={styles.reportName} numberOfLines={1}>
            {item.user?.first_name} {item.user?.last_name}
          </Text>
          <Text style={styles.reportEmail} numberOfLines={1}>
            {item.user?.email}
          </Text>
        </View>

        <View style={styles.colCategory}>
          <Text style={styles.cellText}>
            {item.open_flow_maintenance_issue_category?.name || "—"}
          </Text>
        </View>

        <View style={styles.colRoom}>
          <Text style={styles.cellText}>
            {item.open_flow_maintenance_issue_room_type?.name || "—"}
          </Text>
        </View>

        <View style={styles.colActions}>
          <View style={styles.actionWrapperDesktop}>

            {(item?.status == "completed" || type == "archived") ? null : <TouchableOpacity
              onPress={() => handleUpdateIssueStatus(item)}
              style={[
                styles.statusBtn,
                { backgroundColor: item?.status == "pending" ? "#F59E0B" : "#16A34A" }
              ]}
            >
              <Text style={styles.statusBtnText}>
                {item?.status == "pending" ? 'Mark as In Progress' : 'Mark as Completed'}
              </Text>
            </TouchableOpacity>}

            <TouchableOpacity
              onPress={() => handleView(item)}
              style={styles.viewBtn}
            >
              <Text style={styles.viewText}>
                VIEW
              </Text>
            </TouchableOpacity>

          </View>
        </View>

      </View>
    )
  }
  const handleView = (issue) => {
    setSelectedIssue(issue)
    setOpenModal(true)
  }
  /* ---------------- MOBILE CARD ---------------- */

  const renderMobileCard = ({ item }: any) => {

    const statusStyle = getStatusStyle(item.status)

    return (
      <View style={styles.mobileCard}>

        <View style={styles.mobileHeader}>
          <Text style={styles.mobileTitle}>
            {item.title || "Untitled"}
          </Text>

          <View style={[styles.statusBadge, { backgroundColor: statusStyle.bg }]}>
            <Text style={[styles.statusText, { color: statusStyle.text }]}>
              {item.status?.toUpperCase()}
            </Text>
          </View>
        </View>

        <Text style={styles.mobileDate}>
          {moment(item.date_opened).format("DD MMM YYYY")}
        </Text>

        <View style={styles.mobileSection}>
          <Text style={styles.label}>Reported By</Text>
          <Text style={styles.value}>
            {item.user?.first_name} {item.user?.last_name}
          </Text>
          <Text style={styles.subValue}>{item.user?.email}</Text>
        </View>

        <View style={styles.mobileRow}>
          <View style={{ flex: 1 }}>
            <Text style={styles.label}>Category</Text>
            <Text style={styles.value}>
              {item.open_flow_maintenance_issue_category?.name || "—"}
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text style={styles.label}>Room</Text>
            <Text style={styles.value}>
              {item.open_flow_maintenance_issue_room_type?.name || "—"}
            </Text>
          </View>
        </View>

        {/* Equal Width Buttons */}
        <View style={styles.mobileButtonRow}>

          {(item?.status == "completed" || type == "archived") ? null : <TouchableOpacity
            onPress={() => handleUpdateIssueStatus(item)}
            style={[
              styles.mobileButton,
              { backgroundColor: item?.status == "pending" ? "#F59E0B" : "#16A34A" }
            ]}
          >
            <Text style={styles.statusBtnText}>
              {item?.status == "pending" ? 'Mark as In Progress' : 'Mark as Completed'}
            </Text>
          </TouchableOpacity>
          }
          <TouchableOpacity
            onPress={() => handleView(item)}
            style={[styles.mobileButton, styles.viewBtn]}
          >
            <Text style={styles.viewText}>VIEW</Text>
          </TouchableOpacity>

        </View>

      </View>
    )
  }

  return (
    <View style={{ flex: 1 }}>
      <View style={styles.tableCard}>

        {!isMobile && (
          <View style={styles.headerRow}>
            <Text style={[styles.headerCell, styles.colStatus]}>STATUS</Text>
            <Text style={[styles.headerCell, styles.colTitle]}>TITLE</Text>
            <Text style={[styles.headerCell, styles.colDate]}>DATE</Text>
            <Text style={[styles.headerCell, styles.colReported]}>REPORTED BY</Text>
            <Text style={[styles.headerCell, styles.colCategory]}>CATEGORY</Text>
            <Text style={[styles.headerCell, styles.colRoom]}>ROOM</Text>
            <Text style={[styles.headerCell, styles.colActions, { textAlign: "right" }]}>
              ACTIONS
            </Text>
          </View>
        )}

        <FlatList
          data={list}
          keyExtractor={(item) =>
            item.open_flow_maintenance_issue_id.toString()
          }
          renderItem={isMobile ? renderMobileCard : renderDesktopRow}
        />

      </View>
      <IssueDetailsModal
        open={openModal}
        issue={selectedIssue}
        loader={loader}
        onClose={() => setOpenModal(false)}
        onSummarize={async (issue) => {
          setLoader(true)
          console.log('issue', issue)
          const data = await maintenanceService.summarizeRequest(issue.open_flow_maintenance_issue_id)
          setLoader(false)
          console.log("Summarize data", data)
          setOpenModal(false)
          refresh()

        }}
      />
    </View>
  )
}

export default ActiveProjectIssueTable

const styles = StyleSheet.create({

  tableCard: {
    backgroundColor: "#fff",
    borderRadius: 18,
    padding: 20,
    marginTop: 20,
  },

  headerRow: {
    flexDirection: "row",
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderColor: "#E5E7EB",
  },

  headerCell: {
    fontSize: 12,
    fontWeight: "700",
    color: "#6B7280",
  },

  row: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderColor: "#F1F5F9",
  },

  colStatus: { flex: 1,marginRight:10 },
  colTitle: { flex: 2 },
  colDate: { flex: 1.3 },
  colReported: { flex: 2 },
  colCategory: { flex: 1 },
  colRoom: { flex: 1 },

  colActions: {
    flex: 2,
    alignItems: "flex-end"
  },

  actionWrapperDesktop: {
    flexDirection: "column",
    alignItems: "stretch",
    gap: 10,
    width: 150,
  },


  mobileCard: {
    backgroundColor: "#F9FAFB",
    padding: 16,
    borderRadius: 16,
    marginBottom: 16,
  },

  mobileHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },

  mobileTitle: {
    fontSize: 16,
    fontWeight: "700",
    color: "#111827",
  },

  mobileDate: {
    fontSize: 12,
    color: "#6B7280",
    marginVertical: 6,
  },

  mobileSection: {
    marginVertical: 8,
  },

  mobileRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 10,
  },

  mobileButtonRow: {
    flexDirection: "row",
    gap: 12,
    marginTop: 16,
  },

  mobileButton: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 30,
    alignItems: "center",
  },


  titleText: {
    fontSize: 14,
    fontWeight: "600",
    color: "#111827",
  },

  cellText: {
    fontSize: 13,
    color: "#374151",
  },

  reportName: {
    fontSize: 13,
    fontWeight: "600",
    color: "#111827",
  },

  reportEmail: {
    fontSize: 12,
    color: "#9CA3AF",
  },

  statusBadge: {
    paddingHorizontal: 8,
    paddingVertical: 6,
    borderRadius: 20,
    alignItems: "center",
  },

  statusText: {
    fontSize: 11,
    fontWeight: "600",
  },

  statusBtn: {
    paddingVertical: 10,
    borderRadius: 30,
    alignItems: "center",
  },

  statusBtnText: {
    color: "#fff",
    fontSize: 13,
    fontWeight: "600",
  },

  viewBtn: {
    alignItems: "center",
    paddingVertical: 10,
    borderRadius: 30,
    backgroundColor: COLORS.primary,
  },

  viewText: {
    color: "#fff",
    fontSize: 13,
    fontWeight: "600",
  },

  label: {
    fontSize: 11,
    color: "#6B7280",
  },

  value: {
    fontSize: 13,
    fontWeight: "600",
    color: "#111827",
  },

  subValue: {
    fontSize: 12,
    color: "#9CA3AF",
  },

})
